import { gql } from 'graphql-request';
import withFragments from 'utils/graphql';
import { QuickNavigation } from 'fragments/QuickNavigation';
import FooterFragment from 'fragments/Footer';
import MenuFragment from 'fragments/Menu';
import BrandingFragment from 'fragments/Branding';

const fragments = {
  QuickNavigation,
  FooterFragment,
  MenuFragment,
  BrandingFragment,
};

export default withFragments(
  gql`
    query SiteMap($hostname: String) {
      site(hostname: $hostname) {
        siteName
        isDefaultSite
        unusualopeninghours {
          hideOpeningHours
        }
        pages {
          url
          contentType
          id
        }
        footer {
          ...Footer
        }
        sitebranding {
          ...Branding
        }
        sitesettings {
          ... on SiteSettings {
            showWizard
            gtmId
          }
        }
        mainmenu: mainmenuSet {
          ...Menu
        }
        errorContent: error {
          ... on Error {
            primaryLinkText
            secondaryLinkText
            secondaryLinkPage: secondaryLinkPageSpecific {
              id
              url
              title
            }
          }
        }
        urgentarticle {
          urgentArticle {
            id
            title
            url
          }
        }
      }
      cookiebar {
        title
        text: parsedText
        ctaTitle
        preferenceTitle
        preferenceText
        preferenceCtaTitle
        disclaimer
        essentialCookieText
        targetingCookieText
        thirdPartyCookieText
      }
      redirects(hostname: $hostname) {
        oldPath
        isPermanent
        redirectUrl
        redirectLink
        redirectPath
      }
    }
  `,
  fragments,
);
